import { Body } from "../ui/Typography";

interface BudgetHeaderProps {
  period?: {
    yearFrom: number;
    monthFrom: number;
    yearTo: number;
    monthTo: number;
  };
}

export const BudgetHeader = ({
  period,
}: BudgetHeaderProps) => {
  const formatPeriod = () => {
    if (!period) return "";
    const startPeriod = `${period.yearFrom}-${String(period.monthFrom).padStart(2, '0')}`;
    const endPeriod = `${period.yearTo}-${String(period.monthTo).padStart(2, '0')}`;
    return `${startPeriod} - ${endPeriod}`;
  };

  return (
    <div>
      {period && (
        <Body>
          Budget Period: {formatPeriod()}
        </Body>
      )}
    </div>
  );
};